<template>
  <custom-dialog width="1400px" :title="model.title" :visible="visible" v-on="$listeners" :appendToBody="true">
    <div class="dialog-body">
      <div class="top-btn-content">
        <div class="inner">
          <!-- 确认：显示逻辑-待确认状态 -->
          <el-button :disabled="isSubmit" type="primary" v-if="canCanfirm && funcView.free_accessories_order_confirm" @click="onConfirmHandler">
            {{ funcView.free_accessories_order_confirm }}
          </el-button>
          <el-button type="primary" v-if="canNullify && funcView.free_accessories_order_cancel" @click="showCancel">{{ funcView.free_accessories_order_cancel }}</el-button>
          <el-button type="primary" v-if="canAddStock && funcView.free_accessories_order_add_stock" @click="showDelivery">{{ funcView.free_accessories_order_add_stock }}</el-button>
          <el-button type="primary" v-if="canReturn && funcView.free_accessories_order_return" @click="onReturn">{{ funcView.free_accessories_order_return }}</el-button>
          <!-- 后端说取消了 -->
          <!-- <el-button
            type="primary"
            v-if="canReplacePart && funcView.free_accessories_order_replace_part"
            @click="showReplacePart"
          >{{ funcView.free_accessories_order_replace_part }}</el-button> -->
        </div>
      </div>
      <div class="params-content">
        <ul class="params-ul">
          <li class="params-item">{{ $t('crm_part_order_detail_dialog.ji_shen_hao') }}：{{ info.bodyNum || '-' }}</li>
          <li class="params-item">{{ $t('crm_part_order_detail_dialog.shou_hou_gong_si') }}：{{ info.afterServiceName || '-' }}</li>
          <li class="params-item">{{ $t('crm_part_order_detail_dialog.pei_jian_shu_liang') }}：{{ data.length }}</li>
          <li class="params-item">{{ $t('Common.com_status') }}：{{ getDicValue('giveaway_biz_state', info.bizState) }}</li>
        </ul>
      </div>
      <div class="msg-content">
        <div class="left">
          <!-- 业务信息 -->
          <div class="bus-msg">
            <div class="item-title">{{ $t('crm_part_order_detail_dialog.ye_wu_xin_xi') }}</div>
            <div class="params">
              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.chan_pin_xing_hao') }}：</div>
                    <div class="val">{{ info.productCode || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.ji_shen_hao') }}：</div>
                    <div class="val">{{ info.bodyNum || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.she_bei_lei_xing') }}：</div>
                    <div class="val">{{ info.deviceBizType ? getDicValue('dms_device_biz_type', info.deviceBizType) : '-' }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.ye_wu_zhuang_tai') }}：</div>
                    <div class="val">{{ info.deviceBizState ? getDicValue('order_device_biz_state', info.deviceBizState) : '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.ssywzt') }}：</div>
                    <div class="val">{{ info.realDeviceBizState ? getDicValue('order_device_biz_state', info.realDeviceBizState) : '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.ljzlys') }}：</div>
                    <div class="val">{{ info.totalRentalMonth || '-' }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.zbyszj') }}：</div>
                    <div class="val">{{ info.totalReceivedRentalHq || '-' }}</div>
                  </div>
                </el-col>
                <!-- <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('p_giftPartOrderDetailD_zstj') }}</div>
                    <div class="val">{{ info.triggerCondition || '-' }}</div>
                  </div>
                </el-col> -->
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.he_tong_bian_hao') }}：</div>
                    <div class="val">{{ info.contractNo || '-' }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.jfsqdb') }}：</div>
                    <div class="val">{{ info.partyAName || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.shou_hou_gong_si') }}：</div>
                    <div class="val">{{ info.afterServiceName || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.yi_fang') }}：</div>
                    <div class="val">{{ info.customerName || '-' }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.zhang_qi') }}：</div>
                    <div class="val">{{ info.billTermNum ? `${info.billTermNum}/${info.billTotalTerm}` : '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.zhang_dan_zhuang_tai') }}：</div>
                    <div class="val">{{ getDicValue('rms_order_bill_state', info.billState) }}</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 赠送配件信息 -->
          <div class="part-msg">
            <div class="header">
              <div class="item-title">{{ $t('crm_part_order_detail_dialog.zspjxx') }}</div>
              <div class="table-sum-params">
                <div class="sum-item">
                  <div class="key">{{ $t('crm_part_order_detail_dialog.zeng_song_shu_liang') }}：</div>
                  <div class="val selected-num">{{ info.totalPartNum || '-' }}</div>
                </div>
                <div class="sum-item">
                  <div class="key">{{ $t('crm_part_order_detail_dialog.dai_fa_huo_shu_liang') }}：</div>
                  <div class="val selected-num">{{ info.waitShipNum || '-' }}</div>
                </div>
                <div class="sum-item">
                  <div class="key">{{ $t('crm_part_order_detail_dialog.di_kou_shu_liang') }}：</div>
                  <div class="val selected-num">{{ info.useStockNum || '-' }}</div>
                </div>
                <div class="sum-item">
                  <div class="key">{{ $t('crm_part_order_detail_dialog.cang_ku_shi_fa') }}：</div>
                  <div class="val selected-num">{{ info.realShipNum || '-' }}</div>
                </div>
                <div class="sum-item">
                  <div class="key">{{ $t('crm_part_order_detail_dialog.cun_liu_shu_liang') }}：</div>
                  <div class="val selected-num">{{ info.newStockNum || '-' }}</div>
                </div>
              </div>
            </div>
            <div class="table-container">
              <custom-table tableCode="free_acc_order_gift_parts" :data="data" :slots="['isReturnHq']">
                <template v-slot:isReturnHq="scope">
                  {{ getIsReturnHqView(scope.row) || '-' }}
                </template>
              </custom-table>
            </div>
          </div>

          <!-- 发货信息 -->
          <div class="send-msg">
            <div class="item-title">{{ $t('crm_part_order_detail_dialog.shou_huo_xin_xi') }}</div>
            <div class="params">
              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.shou_huo_ren') }}</div>
                    <div class="val">{{ info.consigneeName || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.lian_xi_dian_hua') }}</div>
                    <div class="val">{{ info.consigneePhone || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.di_zhi') }}</div>
                    <div class="val">{{ info.consigneeAddress || '-' }}</div>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.wu_liu_gong_si') }}</div>
                    <div class="val">{{ info.logisticsCompanyName || '-' }}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="kv">
                    <div class="key">{{ $t('crm_part_order_detail_dialog.wu_liu_dan_hao') }}</div>
                    <div class="val">{{ info.shipmentNum || '-' }}</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="line"></div>
          <div class="flow">
            <div class="title">{{ $t('crm_part_order_detail_dialog.ding_dan_dong_tai') }}</div>
            <ul v-if="flowList.length">
              <li v-for="(item, index) in flowList" :key="index">
                <div class="ub tit ub-xc">
                  <div class="dit1 dit">
                    <div></div>
                  </div>
                  <h1>{{ momentAmPm($momentLocal(item.operateTime)) }}</h1>
                </div>
                <div>
                  <p>{{ $t('crm_part_order_detail_dialog.miao_shu') }}：{{ item.content }}</p>
                  <p>{{ $t('crm_part_order_detail_dialog.cao_zuo_ren') }}：{{ item.userName }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('com_confirm') }}</el-button>
    </div> -->
    <cancel-dialog v-if="cancelVisible" :model="cancelModel" @close="cancelVisible = false" @confirm="onCancelConfirm"></cancel-dialog>
    <return-dialog v-if="returnVisible" @close="returnVisible = false" :model="returnModel" @confirm="onReturnConfirm"></return-dialog>
    <delivery-dialog v-if="deliveryVisible" @close="deliveryVisible = false" :model="deliveryModel" v-model="deliveryVisible" @success="onDeliveryConfirm"></delivery-dialog>
    <replace-part-dialog v-if="replacePartVisible" :model="replacePartModel" @close="replacePartVisible = false" @confirm="onReplacePartConfirm"></replace-part-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import mixins from '../freeAccessoriesOrder/children/mixins.js';
import cancelDialog from '../freeAccessoriesOrder/children/cancel_dialog.vue';
import returnDialog from '../freeAccessoriesOrder/children/return_dialog.vue';
import deliveryDialog from '../freeAccessoriesOrder/children/delivery_dialog';
import replacePartDialog from '../freeAccessoriesOrder/children/replace_part_dialog.vue';

export default {
  mixins: [dialogMixins, mixins],
  components: {
    cancelDialog,
    returnDialog,
    deliveryDialog,
    replacePartDialog,
  },
  data() {
    return {
      flowList: [],
      info: {},

      data: [],

      // 作废
      cancelVisible: false,
      cancelModel: {},

      // 退货
      returnVisible: false,
      returnModel: {},

      // 新增出库单
      deliveryVisible: false,
      deliveryModel: {},

      // 更换配件
      replacePartVisible: false,
      replacePartModel: {},

      isSubmit: false,
    };
  },
  computed: {
    // 是否能：确认
    // 待确认状态   （订单号要求相同，但是因为只有一个数据，所以不需要判断）
    canCanfirm() {
      if (!this.dicMap.giveaway_biz_state) {
        return false;
      }

      // 是否：待确认
      const isWaitConfirm = `${this.info.bizState}` === `${this.dicMap.giveaway_biz_state.wait_confirm}`;

      return isWaitConfirm;
    },
    // 是否能：更换配件
    canReplacePart() {
      if (!this.dicMap.giveaway_biz_state) {
        return false;
      }

      // 是否：待确认
      const isWaitConfirm = `${this.info.bizState}` === `${this.dicMap.giveaway_biz_state.wait_confirm}`;

      return isWaitConfirm;
    },
    // 是否能：作废
    // 待确认、已确认 && 总部用户
    canNullify() {
      if (!this.dicMap.giveaway_biz_state) {
        return false;
      }

      const { confirmed } = this.dicMap.giveaway_biz_state;
      const waitConfirm = this.dicMap.giveaway_biz_state.wait_confirm;

      // 是否总部用户
      const isHq = this.isHq;

      const checkState = [`${waitConfirm}`, `${confirmed}`].includes(`${this.info.bizState}`);

      return isHq && checkState;
    },

    // 是否能：退货
    // 已完成 && 总部
    canReturn() {
      if (!this.dicMap.giveaway_biz_state) {
        return false;
      }

      const { finish } = this.dicMap.giveaway_biz_state;

      // 是否总部用户
      const isHq = this.isHq;

      const checkState = `${finish}` === `${this.info.bizState}`;

      return isHq && checkState;
    },

    // 是否能：新增出库单
    // 已确认
    canAddStock() {
      if (!this.dicMap.giveaway_biz_state) {
        return false;
      }

      // 是否总部用户
      const isHq = this.isHq;

      const { confirmed } = this.dicMap.giveaway_biz_state;

      const checkState = `${confirmed}` === `${this.info.bizState}`;

      return isHq && checkState;
    },
  },
  mounted() {
    this.getDicMap('giveaway_biz_state');
    this.getDicMap('fms_bill_state');
    this.getFuncView('/crmStock/freeAccessoriesOrder');

    this.init();
  },
  methods: {
    getIsReturnHqView(row) {
      const bizState = `${row.bizState}`;
      const isReturnHq = row.isReturnHq;
      // bizState giveaway_biz_state
      // 已退货 ： 90
      // isReturnHq isynergy_cloud_bool
      //
      if (bizState === '90') {
        return this.getDicValue('isynergy_cloud_bool', isReturnHq);
      }
      return '-';
    },
    // 更换配件
    showReplacePart() {
      this.replacePartModel = {
        title: this.$t('crm_part_order_detail_dialog.geng_huan_pei_jian'),
        data: [this.info],
      };

      this.replacePartVisible = true;
    },
    onReplacePartConfirm() {
      this.init();
      this.onInfoChange('replace');
    },
    // 新增出库单
    showDelivery() {
      this.deliveryModel = {
        title: this.$t('crm_part_order_detail_dialog.xin_zeng_chu_ku_dan'),
        data: [this.info],
      };
      this.deliveryVisible = true;
    },

    onDeliveryConfirm() {
      this.init();
      this.onInfoChange('addStock');
    },

    onReturnConfirm() {
      this.init();
      this.onInfoChange('return');
    },
    onReturn() {
      const row = this.info;
      const tit = this.$t('crm_part_order_detail_dialog.tui_huo');
      const title = `${tit}（${row.bodyNum}）`;
      this.returnModel = {
        title: title,
        data: row,
      };
      this.returnVisible = true;
    },

    // 作废
    showCancel() {
      this.cancelModel = {
        title: this.$t('crm_part_order_detail_dialog.zuo_fei'),
        data: [this.info],
      };
      this.cancelVisible = true;
    },

    onCancelConfirm() {
      this.init();
      this.onInfoChange('cancel');
    },

    onInfoChange(type) {
      if (type) {
        this.$emit(type);
      }
      this.$emit('infoChange');
    },

    onConfirmHandler() {
      this.$showConfirm(this.$t('crm_part_order_detail_dialog.nqdsxzsdpjxxsyxdm')).then(() => {
        const orderGoodsCode = this.info.orderGoodsCode;
        const reqData = {
          orderGoodsCode,
        };
        const url = `${apis.giveawayConfirm}/${orderGoodsCode}`;

        if (this.isSubmit) {
          return;
        } else {
          this.isSubmit = true;
        }

        this.$postJSON(url, reqData)
          .then(() => {
            this.isSubmit = false;
            this.init();
            this.onInfoChange('confirm');
          })
          .catch(() => {
            this.isSubmit = false;
          });
      });
    },

    init() {
      const row = this.model.data;

      const reqData = {
        orderGoodsCode: row.orderGoodsCode,
      };

      this.$getJSON(apis.giveawayDetail, reqData).then((res) => {
        this.info = res.data;
        this.data = this.info.partList;
      });

      this.$getJSON(apis.giveawayLog, {
        orderGiveawayId: row.orderGiveawayId,
      }).then((res) => {
        this.flowList = res.data;
      });
    },
    onConfirm() {
      this.$emit('confirm');
      this.close();
    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.top-btn-content {
  overflow: hidden;
  padding-bottom: 24px;

  .inner {
    float: right;
  }
}

.params-content {
  padding: 10px;
  background-color: rgb(245, 245, 245);

  .params-ul {
    overflow: hidden;

    .params-item {
      float: left;
      min-width: 20%;
      font-size: 12px;
      line-height: 20px;
      padding-right: 20px;
    }
  }
}

.msg-content {
  display: flex;
  flex-direction: row;
  .left {
    flex: 1;

    width: 0;

    .bus-msg {
      margin-top: 24px;
    }

    .part-msg {
      margin-top: 35px;

      .header {
        overflow: hidden;
        .item-title {
          float: left;
        }

        .table-sum-params {
          float: right;
          overflow: hidden;

          .sum-item {
            float: left;
            line-height: 22px;
            font-size: 12px;
            color: #606266;

            &:last-child {
              .selected-num {
                padding: 0;
              }
            }

            .selected-num {
              padding: 0 20px 0 0;
              color: #0d9ae0;
            }

            .key,
            .val {
              float: left;
            }
          }
        }
      }

      .table-container {
        overflow: hidden;
      }
    }

    .send-msg {
      margin-top: 35px;
    }

    .params {
      .kv {
        overflow: hidden;
        display: flex;
        font-size: 12px;
        line-height: 16px;
        padding: 10px 0;

        .key {
          width: 120px;
        }
        .val {
          flex: 1;
          padding-right: 10px;
        }
      }
    }
  }

  .right {
    width: 350px;
    background-color: #fff;
    margin-left: 20px;
    padding-bottom: 10px;
    position: relative;

    .line {
      position: absolute;
      left: 0;
      top: 24px;
      bottom: 0;
      width: 1px;
      margin: auto;
      background: #ccc;
    }

    .flow {
      padding: 25px 0 25px 32px;
      min-height: 500px;
      max-height: 700px;
      overflow-y: auto;

      .title {
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
        padding-bottom: 20px;
      }

      .dit1.dit {
        background-color: #ffffff;
        padding: 5px;
        width: 20px;
        div {
          background-color: #4a90e2;
          width: 11px;
          height: 11px;
          border-radius: 7px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 3px;
            top: 3px;
            z-index: 1;
            width: 5px;
            height: 5px;
            border-radius: 6px;
            background-color: #ffffff;
          }
        }
      }

      .dit1 {
        background-color: #ffffff;
        padding: 3px 6px;
        width: 20px;
        div {
          background-color: #8c8c8c;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: relative;
        }
      }
      ul > li {
        padding: 14px 20px 44px 23px;
        border-left: 1px solid #bfbfbf;
        position: relative;
        word-break: break-all;
        box-sizing: content-box;
        &:last-child {
          border-left: 1px solid #ffffff;
        }
        .tit {
          position: absolute;
          top: -12px;
          left: -11px;
        }
        h1 {
          color: #495057;
          font-size: 12px;
          line-height: 24px;
          margin-left: 14px;
          font-weight: 500;
        }
        p {
          font-size: 12px;
          color: #6c757d;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
